import { callApi } from '@local_modules/generic/fetch.js'
import dayjs from 'dayjs'

export async function callCheckUpToDate (gridApi, entityId) {
  const [latestXeroJournalResponse, latestSyncedJournalResponse] = await Promise.all([
    checkLatestXeroJournal(entityId),
    checkLatestSyncedJournal(entityId)
  ])

  const gridRowNode = gridApi.getRowNode(entityId)
  gridRowNode.data.checkUpToDate = {}

  const latestXeroJournalNumber = latestXeroJournalResponse.latestXeroJournal?.number
  const latestXeroJournalCreatedAt = latestXeroJournalResponse.latestXeroJournal?.xero_created_at

  const latestSyncedJournalNumber = latestSyncedJournalResponse.number
  const latestSyncedJournalCreatedAt = latestSyncedJournalResponse.xero_created_at

  const isUpToDate = latestXeroJournalNumber === latestSyncedJournalNumber && latestXeroJournalCreatedAt === latestSyncedJournalCreatedAt

  if (isUpToDate) {
    gridRowNode.data.checkUpToDate.isUpToDate = true

    const feedback = `Up to date with latest journal at ${dayjs(latestSyncedJournalCreatedAt).format('DD MMM YYYY @ HH:mm')}`
    gridRowNode.data.checkUpToDate.feedback = feedback
  } else {
    gridRowNode.data.checkUpToDate.isUpToDate = false

    const feedback = `${latestXeroJournalNumber - latestSyncedJournalNumber} journals not synced between ${dayjs(latestSyncedJournalCreatedAt).format('DD MMM YYYY @ HH:mm')} and ${dayjs(latestXeroJournalCreatedAt).format('DD MMM YYYY @ HH:mm')}`
    gridRowNode.data.checkUpToDate.feedback = feedback
  }
}

async function checkLatestXeroJournal (entityId) {
  const apiResponse = await callApi('/api/sync-pg/:accountingOrganisationId/find-latest-xero-journal', {
    accountingOrganisationId: entityId
  }, { method: 'GET' })

  console.log('apiResponse', apiResponse)
  return apiResponse
}

async function checkLatestSyncedJournal (entityId) {
  const apiResponse = await callApi('/api/sync-pg/:accountingOrganisationId/find-latest-synced-journal', {
    accountingOrganisationId: entityId
  }, { method: 'GET' })

  console.log('apiResponse', apiResponse)
  return apiResponse
}
